import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import RangeSlider from 'components/elements/RangeSlider';
import IconColorPicker from 'components/dashboard/links-content/LinkIcons/IconColorPicker';

import './SettingsSlider.css';

const SettingsSlider = ({
  className,
  label,
  min,
  max,
  defaultValue,
  step,
  onChange,
  value,
  prefix,
  onChangeComplete,
  type,
  onResetClick,
}) => {
  const { t } = useTranslation();

  const renderSettingsItem = () => {
    switch (type) {
      case 'slider':
        return (
          <RangeSlider
            className="icons-settings-slider__slider"
            min={min}
            max={max}
            defaultValue={defaultValue}
            step={step}
            onChange={onChange}
            value={value}
          />
        );
      case 'color-picker':
        return (
          <IconColorPicker
            color={value || '#000000'}
            onChangeComplete={onChangeComplete}
          />
        );
      case 'reset':
        return (
          <div className="icons-reset-settings" onClick={onResetClick}>{t("Reset All Settings")}</div>
        );
      default:
        return (
          <RangeSlider
            className="icons-settings-slider__slider"
            min={min}
            max={max}
            defaultValue={defaultValue}
            step={step}
            onChange={onChange}
            value={value}
          />
        );
    }
  };

  return (
    <div className={`icons-settings-slider__component ${className} ${type}`}>
      <div className="icons-settings-slider-wrapper">
        {label &&
          <div className="icons-settings-slider-label">{label}</div>
        }
        {renderSettingsItem()}

        {value &&
          <div className="icons-settings-slider-value">{value}{prefix}</div>
        }
      </div>
    </div>
  );
};

SettingsSlider.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  defaultValue: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prefix: PropTypes.string,
  colorPicker: PropTypes.bool,
  onChangeComplete: PropTypes.func,
  type: PropTypes.oneOf(['slider', 'color-picker', 'reset']),
  onResetClick: PropTypes.func,
};
SettingsSlider.defaultProps = {
  className: '',
  label: '',
  min: 0,
  max: 100,
  defaultValue: 1,
  step: 1,
  onChange: null,
  value: 0,
  prefix: '',
  colorPicker: false,
  onChangeComplete: null,
  type: 'slider',
  onResetClick: null,
};

export default SettingsSlider;
